import { ClientError } from '@eversports/react-components/client-error'
import Heading from '@eversports/react-components/primitives/Heading'
import Logo from '@eversports/react-components/primitives/Logo'

import VenueImage from './VenueImage'

interface LogoWrapperProps {
  brandingName: string | null
  logoUrl: string | null
  error?: ClientError
}

const VenueLogo = ({ brandingName, logoUrl, error }: LogoWrapperProps) => {
  if (error) {
    return <Logo type="horizontal" height="32px" />
  }

  return (
    <>
      {logoUrl && <VenueImage backgroundUrl={logoUrl} width="80px" height="80px" />}
      {brandingName && (
        <Heading
          is="h1"
          textAlign="center"
          style={{
            marginTop: logoUrl ? '16px' : '96px',
            whiteSpace: 'nowrap',
          }}
        >
          {brandingName}
        </Heading>
      )}
    </>
  )
}

export default VenueLogo
